import React from "react";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import { injectIntl } from "react-intl";

const MuiPickersProvider = ({ intl, children }) => {
  const locale = intl.locale || "en";

  return (
    <MuiPickersUtilsProvider utils={MomentUtils} locale={locale} moment={moment}>
      {children}
    </MuiPickersUtilsProvider>
  );
};

export default injectIntl(MuiPickersProvider);
